import { useMutation, useQueryClient } from '@tanstack/react-query';
import graphqlClient from '@/graphql/graphql-client';
import {
  DeleteOrganizationDocument,
  type DeleteOrganizationMutationVariables,
} from '@/graphql/generated/graphql';

export const useDeleteOrganization = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['delete-organization'],
    mutationFn: (variables: DeleteOrganizationMutationVariables) =>
      graphqlClient.request(DeleteOrganizationDocument, variables),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organizations'] });
    },
  });
};

export const DELETE_ORGANIZATION_MUTATION = DeleteOrganizationDocument;
